import { useEffect } from 'react';
import { Navigate, useNavigate, Link } from 'react-router-dom';
import { APP_ROUTES } from '../appRoutes';
import { authStorage } from '../utils/storage';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


import {
  faDoorOpen,
  faPersonMilitaryPointing
} from '@fortawesome/free-solid-svg-icons';

function Header() {
  const userId = authStorage.getUserId();
  const userName = authStorage.getUserName();
  const userTipo = authStorage.getUserType();


const estilo = {
  background: "linear-gradient(90deg, rgb(138, 6, 6), rgba(2, 94, 110))",
  padding: "0px",
  margin: "0px",
  color: "#ffffff"
};

  let tipoUsuario;

  if (userTipo === 'admin') 
  {
    tipoUsuario = 'Administrador';
  } 
  else if (userTipo === 'supervisor')  
  {
    tipoUsuario = 'Supervisor';
  }
  else{
    tipoUsuario = 'Usuario';
  }

  const navigate = useNavigate();

  const handleLogout = () => {
    authStorage.clearUserSession();
    navigate(APP_ROUTES.login);
  };

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      e.preventDefault();
      e.returnValue = '';
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  if (!userId) {
    return <Navigate to={APP_ROUTES.login} />;
  }

  return (
    // <nav className="navbar navbar-expand-lg navbar-dark fixed-top"style={estilo}>
    <nav className="navbar navbar-expand-lg navbar-dark" style={estilo}>
      <div className="container">
        <Link className="navbar-brand nav-link" to={APP_ROUTES.inicio}>
          {/* <FontAwesomeIcon icon={faHouseUser}  /> */}
          <img className='' alt='' src="/Logo.png" width="140" height="80"/>  
        </Link>

        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse " id="navbarNav">
          <ul className="navbar-nav ">
            <li className="nav-item ">
              <Link className="nav-link" to={APP_ROUTES.minutas}>
                Minutas
              </Link>
            </li>
            {userTipo === 'admin' && (
              <li className="nav-item">
                <Link className="nav-link" to={APP_ROUTES.usuarios}>
                  Usuarios
                </Link>
              </li>
            )}
            {userTipo === 'admin' && (
              <li className="nav-item">
                <Link className="nav-link" to={APP_ROUTES.sedes}>
                  Sedes
                </Link>
              </li>
            )}

            {(userTipo === 'admin' || userTipo === 'supervisor') && (
              <li className="nav-item">
                <Link className="nav-link" to={APP_ROUTES.informes}>
                  Informes
                </Link>
              </li>
            )}
              {userTipo === 'admin' && (
              <li className="nav-item">
                <Link className="nav-link" to={APP_ROUTES.guia}>
                  Guia
                </Link>
              </li>
            )}
          </ul>
          {/* Elemento "Perfil" en el extremo derecho */}
          <ul className="navbar-nav ms-auto mr-0">
            <li className="nav-item dropdown ">
              <a
                className="nav-link text-white "
                id="perfilDropdown"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                href="#."
              >
                <div className="text-center ">
                  <div >{userName} </div>
                  <div className="small">
                    {tipoUsuario}{' '}
                    <FontAwesomeIcon icon={faPersonMilitaryPointing} />
                  </div>
                </div>
              </a>
               <ul className="dropdown-menu bg-secondary " aria-labelledby="perfilDropdown">
        
                <li>
                  <button className="dropdown-item small bg-secondary  text-white" onClick={handleLogout}>
                      <FontAwesomeIcon icon={faDoorOpen} /> Salir
                  </button>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Header;
